
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"9.555","y":".432","width":"16","height":"2","rx":"1","transform":"rotate(90 9.555 .432)","fill":"currentColor"}}),_c('rect',{attrs:{"x":".555","y":"7.432","width":"16","height":"2","rx":"1","fill":"currentColor"}})])
          )
        }
      }
    